import React from "react";
import { AccountModal } from "./styles"

export default props => {
    return (
        <AccountModal
            visible={props.visible}
            title={props.title}
            centered
            onCancel={props.onCancel} cancelText={props.cancelText}
            onOk={props.onOk} okText={props.okText} okType={props.okType}
            footer={props.footer}>
            {props.children}
        </AccountModal>
    )
}